import React, { createContext, useContext, useMemo } from "react";
import { useCompanyPrintLabelStats } from "../../../hooks/useCompanyPrintLabelStats";
import { getProductionLabelList } from "../../../utils/printLabelStatsUtils";

const CompanyPrintLabelStatsContext = createContext(null);

export function CompanyPrintLabelStatsProvider({ companyId, children }) {
  const state = useCompanyPrintLabelStats(companyId);

  const companyWideLabels = useMemo(
    () => getProductionLabelList(state.stats?.companyWide),
    [state.stats],
  );

  const value = useMemo(() => {
    const getLabelsForProduction = (productionId) => {
      const id = Number(productionId);
      const map = state.stats?.byProductionId?.get(id);
      return getProductionLabelList(map);
    };

    return {
      ...state,
      companyWideLabels,
      getLabelsForProduction,
      getCompanyWideLabels: () => companyWideLabels,
    };
  }, [
    state.loading,
    state.error,
    state.stats,
    state.period,
    state.periodHint,
    state.canView,
    companyWideLabels,
  ]);

  return (
    <CompanyPrintLabelStatsContext.Provider value={value}>
      {children}
    </CompanyPrintLabelStatsContext.Provider>
  );
}

export function useCompanyPrintLabelStatsContext() {
  const ctx = useContext(CompanyPrintLabelStatsContext);
  if (!ctx) {
    throw new Error(
      "useCompanyPrintLabelStatsContext must be used within CompanyPrintLabelStatsProvider",
    );
  }
  return ctx;
}

/** Safe for components that may render outside CompanyCard (no-op). */
export function useOptionalCompanyPrintLabelStatsContext() {
  return useContext(CompanyPrintLabelStatsContext);
}
